import React, { useEffect, useState } from "react";
import consts from "../../consts";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import { DefinirEnergiaDiaForm } from "./DefinirEnergiaDiaForm.jsx";
import { getListaGraficoEnergiaDiasMes, incluirEnergiaDia, montarGraficoColunasEnergiaDiasMes, setDataGrafico } from "../geracaoLeituraActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IndicadorParcialRendimentoMensal } from "./IndicadorParcialRendimentoMensal.jsx";


function GraficoMesComponent(props) {
    const [graficoMes, setGraficoMes] = useState(null);

    const podeIncluirRegistrosManualmente =
        !props.filtro.agrupar_por_uc && props.registro.id_geracao_integracao && !props.usuarioLogado.acesso_cliente && props.usuarioLogado.acesso_solar_editar;

    const exibirFormularioIncluirEnergiaDia = props.modoTela === "graficoEnergiaDiasMes" && podeIncluirRegistrosManualmente;

    useEffect(() => {
        props.getListaGraficoEnergiaDiasMes({
            id_agrupador: props.filtro.agrupar_por_uc ? props.registro.id_unidade_consumidora : props.registro.id_geracao_integracao,
            data: props.dataGrafico,
        });
    }, [props.filtro.agrupar_por_uc, props.registro.id_unidade_consumidora, props.registro.id_geracao_integracao, props.dataGrafico]);

    useEffect(() => {
        montarGraficoColunasEnergiaDiasMes({
            id: "graficoEnergiaMes",
            lista: props.listaGraficoEnergiaDiasMes,
            setChart: setGraficoMes,
            subtitulo: props.registro.nome_unidade_consumidora,
        });
        return () => {
            if (graficoMes) {
                graficoMes.dispose();
            }
        };
    }, [props.listaGraficoEnergiaDiasMes, props.registro.nome_unidade_consumidora]);

    function voltarAvancarDataGrafico({ dataGrafico, tempo }) {
        const novaData = new Date(dataGrafico);
        novaData.setUTCMonth(novaData.getUTCMonth() + tempo);
        props.setDataGrafico(novaData.toISOString().substring(0, 10));
    }

    function getEstiloBotao(desabilitado) {
        return {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "1.5rem",
            fontWeight: 500,
            boxShadow: desabilitado ? "inset 0 0 16px 1px #ccc" : "0 0 10px 1px #ccc",
            color: "#0070cc",
            width: 40,
            height: 40,
            borderRadius: "100%",
            backgroundColor: "#fff",
            border: "none",
            marginInline: 20,
        };
    }

    return (
        <Row>
            <Grid cols="12 4 4 4" style={{ display: "flex", justifyContent: "center" }}>
                <IndicadorParcialRendimentoMensal dataGrafico={props.dataGrafico} listaDiasMes={props.listaGraficoEnergiaDiasMes} />
            </Grid>
            <Grid
                cols={"12 4 4 4"}
                style={{
                    display: "flex",
                    minWidth: "fit-content",
                    justifyContent: "center",
                    alignItems: "center",
                    paddingTop: 10,
                }}
            >
                <button
                    style={getEstiloBotao()}
                    onFocus={(e) => {
                        e.target.style.outline = "none";
                    }}
                    onClick={() => {
                        voltarAvancarDataGrafico({
                            dataGrafico: props.dataGrafico,
                            tempo: -1,
                        });
                    }}
                    disabled={false}
                >
                    {"<"}
                </button>
                <select
                    style={{
                        fontSize: "1.2rem",
                        padding: 7,
                        border: "1px solid #999",
                        backgroundColor: "#fff",
                        borderRadius: 10,
                    }}
                    value={props.dataGrafico.substring(5, 7)}
                    onFocus={(e) => (e.target.style.outline = "none")}
                    onChange={(e) => {
                        const dataAtual = props.dataGrafico;
                        const novaData = dataAtual.substring(0, 5) + e.target.value + "-01";

                        const dataMaiorQueAtual = new Date(novaData).getTime() > new Date().getTime();
                        if (!dataMaiorQueAtual) {
                            props.setDataGrafico(novaData);
                        }
                    }}
                >
                    <option value="01">Janeiro</option>
                    <option value="02">Fevereiro</option>
                    <option value="03">Março</option>
                    <option value="04">Abril</option>
                    <option value="05">Maio</option>
                    <option value="06">Junho</option>
                    <option value="07">Julho</option>
                    <option value="08">Agosto</option>
                    <option value="09">Setembro</option>
                    <option value="10">Outubro</option>
                    <option value="11">Novembro</option>
                    <option value="12">Dezembro</option>
                </select>
                <select
                    style={{
                        marginLeft: 5,
                        fontSize: "1.2rem",
                        padding: 7,
                        border: "1px solid #999",
                        backgroundColor: "#fff",
                        borderRadius: 10,
                    }}
                    value={props.dataGrafico.substring(0, 4)}
                    onFocus={(e) => (e.target.style.outline = "none")}
                    onChange={(e) => {
                        const novaData = e.target.value + "-" + props.dataGrafico.substring(5, 7) + "-01";
                        props.setDataGrafico(novaData);
                    }}
                >
                    {Array.from({ length: new Date().getFullYear() - consts.ANO_INICIO_MONITORAMENTO_SOLAR + 1 }, (_, i) => {
                        const year = consts.ANO_INICIO_MONITORAMENTO_SOLAR + i;
                        return (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        );
                    })}
                </select>
                <button
                    style={getEstiloBotao(props.dataGrafico.substring(0, 7) === new Date().toISOString().substring(0, 7))}
                    onFocus={(e) => {
                        e.target.style.outline = "none";
                    }}
                    onClick={() => {
                        voltarAvancarDataGrafico({
                            dataGrafico: props.dataGrafico,
                            tempo: 1,
                        });
                    }}
                    disabled={props.dataGrafico.substring(0, 7) === new Date().toISOString().substring(0, 7)}
                >
                    {">"}
                </button>
            </Grid>
            {exibirFormularioIncluirEnergiaDia && (
                <Grid
                    cols="12 4 4 4"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        minWidth: "fit-content",
                        paddingTop: 28,
                    }}
                >
                    <DefinirEnergiaDiaForm
                        dataGrafico={props.dataGrafico}
                        idGeracaoIntegracao={props.registro.id_geracao_integracao}
                        handleSubmit={(form) => {
                            props.incluirEnergiaDia({
                                registro: form,
                                callback: () => {
                                    props.getListaGraficoEnergiaDiasMes({
                                        id_agrupador: props.registro.id_geracao_integracao,
                                        data: props.dataGrafico,
                                    });
                                },
                            });
                        }}
                    />
                </Grid>
            )}

            <div
                id="graficoEnergiaMes"
                style={{
                    width: "100%",
                    backgroundColor: "#ffffff",
                    height: 600,
                    borderRadius: "0 0 8px 8px",
                    overflow: "hidden",
                }}
            ></div>
        </Row>
    );
}
const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        filtro: state.geracaoLeitura.filtro,
        modoTela: state.geracaoLeitura.modoTela,
        registro: state.geracaoLeitura.registro,
        dataGrafico: state.geracaoLeitura.dataGrafico,
        listaGraficoEnergiaDiasMes: state.geracaoLeitura.listaGraficoEnergiaDiasMes,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getListaGraficoEnergiaDiasMes,
            setDataGrafico,
            incluirEnergiaDia,
        },
        dispatch
    );
export const GraficoMes = connect(mapStateToProps, mapDispatchToProps)(GraficoMesComponent);
